/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_New_Folder_TextInputs */

const en_explorer_display_new_folder_text = /** @type {(inputs: Explorer_Display_New_Folder_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a folder name:`)
};

const fr_explorer_display_new_folder_text = /** @type {(inputs: Explorer_Display_New_Folder_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer un nom de dossier :`)
};

const de_explorer_display_new_folder_text = /** @type {(inputs: Explorer_Display_New_Folder_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie einen Ordnernamen ein:`)
};

const it_explorer_display_new_folder_text = /** @type {(inputs: Explorer_Display_New_Folder_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un nome per la cartella:`)
};

const ru_explorer_display_new_folder_text = /** @type {(inputs: Explorer_Display_New_Folder_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, введите название папки:`)
};

const es_explorer_display_new_folder_text = /** @type {(inputs: Explorer_Display_New_Folder_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduzca un nombre de carpeta:`)
};

const zh_cn2_explorer_display_new_folder_text = /** @type {(inputs: Explorer_Display_New_Folder_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入文件夹名称：`)
};

const ja_explorer_display_new_folder_text = /** @type {(inputs: Explorer_Display_New_Folder_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダ名を入力してください:`)
};

const hi_explorer_display_new_folder_text = /** @type {(inputs: Explorer_Display_New_Folder_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया फ़ोल्डर का नाम दर्ज करें:`)
};

const pt_pt2_explorer_display_new_folder_text = /** @type {(inputs: Explorer_Display_New_Folder_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira o nome da pasta:`)
};

/**
* | output |
* | --- |
* | "Please enter a folder name:" |
*
* @param {Explorer_Display_New_Folder_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_new_folder_text = /** @type {((inputs?: Explorer_Display_New_Folder_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_New_Folder_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_new_folder_text(inputs)
	if (locale === "de") return de_explorer_display_new_folder_text(inputs)
	if (locale === "it") return it_explorer_display_new_folder_text(inputs)
	if (locale === "ru") return ru_explorer_display_new_folder_text(inputs)
	if (locale === "es") return es_explorer_display_new_folder_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_new_folder_text(inputs)
	if (locale === "ja") return ja_explorer_display_new_folder_text(inputs)
	if (locale === "hi") return hi_explorer_display_new_folder_text(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_new_folder_text(inputs)
	return en_explorer_display_new_folder_text(inputs)
});